import { IRiskHRCase } from '@logicalcommander/types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

const initialState: IRiskHRCase = {} as IRiskHRCase

export const caseSlice = createSlice({
  name: 'caseReducer',
  initialState,
  reducers: {
    setActiveCase: (state, action: PayloadAction<IRiskHRCase>) => {
      return action.payload
    },
  },
})

export const { setActiveCase } = caseSlice.actions
export default caseSlice.reducer
export const selectActiveCase = (state: RootState): IRiskHRCase => state.caseReducer
